// extracted by mini-css-extract-plugin
module.exports = {"animationD":"animationD_animationD__m_xA3"};